import { APITypes } from '../../primary-record-types';
import { useMutation } from '@tanstack/react-query';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import _ from 'lodash';
import { getIntl } from '../../utils/intl';
import useNotify from '../useNotify';
import { useOrganizationId } from './useOrganization';

const intl = getIntl('useOrganizationClientRecordInvitationFile', {
    fileLoadError: 'Failed to load file',
});

export type UseOrganizationClientRecordInvitationFileArgs = {
    onLoadClientRecordInvitationFileSuccess: (
        args: APITypes.organizationService.GetOrganizationClientRecordInvitationFileDownloadUrlResponse,
    ) => void;
};

export type OnLoadClientRecordInvitationFileArgs = {
    organizationClientRecordId: string;
    fileId: string;
};

export type UseOrganizationClientRecordInvitationFileReturnValue = {
    onLoadClientRecordInvitationFile: (args: OnLoadClientRecordInvitationFileArgs) => void;
    isLoadingClientRecordInvitationFile: boolean;
};

export const useOrganizationClientRecordInvitationFile = ({
    onLoadClientRecordInvitationFileSuccess,
}: UseOrganizationClientRecordInvitationFileArgs): UseOrganizationClientRecordInvitationFileReturnValue => {
    const notify = useNotify();
    const organizationId = useOrganizationId();

    const loadClientRecordInvitationFileMutation = useMutation({
        mutationFn: async (args: OnLoadClientRecordInvitationFileArgs) => {
            return appAPI.get<APITypes.organizationService.GetOrganizationClientRecordInvitationFileDownloadUrlResponse>(
                urls.api.organizations.clientRecords.clientRecordInvitationFile(
                    organizationId,
                    args.organizationClientRecordId,
                    args.fileId,
                ),
            );
        },
        onSuccess: (data) => {
            onLoadClientRecordInvitationFileSuccess(data);
        },
        onError: () => {
            notify('error', intl('fileLoadError'));
        },
    });

    return {
        onLoadClientRecordInvitationFile: loadClientRecordInvitationFileMutation.mutate,
        isLoadingClientRecordInvitationFile: loadClientRecordInvitationFileMutation.isPending,
    };
};
